import React, { useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useUser } from '../hooks/queries/useAuth';
import { logger } from '../utils/logger';

export function PublicRoute() {
  const { data: user, isPending: userPending } = useUser();

  // Log state for debugging
  useEffect(() => {
    if (userPending) {
      logger.component('PublicRoute: Auth check pending', {
        timestamp: new Date().toISOString()
      });
    } else if (user) {
      logger.component('PublicRoute: User authenticated, will redirect to private route', {
        userId: user.id,
        timestamp: new Date().toISOString()
      });
    } else {
      logger.component('PublicRoute: No user, showing public content', {
        timestamp: new Date().toISOString()
      });
    }
  }, [user, userPending]);

  // If user is authenticated and auth check is complete, redirect to private area
  // The private route will handle determining the actual destination
  if (!userPending && user) {
    return <Navigate to="/app" replace />;
  }

  // Always render the outlet for public routes
  // This ensures the landing page loads immediately
  return <Outlet />;
}

export default PublicRoute;
